/*
  Brochure-leadmagnet (snippets/dms-product-tabs.liquid, fanen "Brochure").
  Knappen "Hent brochure" åbner popup'en #brochureModal. Formularen sender navn + e-mail
  + produktets handle til lead-backenden dms-leads (/brochure-lead), som mailer brochuren.
*/
(function () {
  if (window.__dmsBrochureLead) return;
  window.__dmsBrochureLead = true;

  var ENDPOINT = "https://dms-leads.vercel.app/brochure-lead";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var lastTrigger = null;

  function modal() {
    return document.getElementById("brochureModal");
  }

  function open(trigger) {
    var m = modal();
    if (!m) return;
    if (m.parentElement !== document.body) document.body.appendChild(m);
    lastTrigger = trigger || null;
    m.style.display = "block";
    document.documentElement.style.overflow = "hidden";
    var first = m.querySelector('input[name="name"]');
    if (first && !m.querySelector(".dms-brochure-form").hidden) setTimeout(function () { first.focus(); }, 50);
  }

  function close() {
    var m = modal();
    if (!m) return;
    m.style.display = "none";
    document.documentElement.style.overflow = "";
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest && event.target.closest("[data-dms-brochure-open]");
    if (opener) {
      event.preventDefault();
      open(opener);
      return;
    }
    if (event.target.closest && event.target.closest("[data-dms-brochure-close]")) {
      close();
      return;
    }
    if (event.target === modal()) close();
  });

  document.addEventListener("keydown", function (event) {
    var m = modal();
    if (event.key === "Escape" && m && m.style.display === "block") close();
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-dms-brochure-form]");
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var nameEl = form.querySelector('[name="name"]');
    var emailEl = form.querySelector('[name="email"]');
    var errorEl = form.querySelector(".dms-form-error");
    var button = form.querySelector('[type="submit"]');
    var name = nameEl.value.trim();
    var email = emailEl.value.trim();

    function showError(message, field) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      if (field) field.focus();
    }
    errorEl.hidden = true;

    if (!name) return showError("Udfyld dit navn.", nameEl);
    if (!EMAIL_RE.test(email)) return showError("Udfyld en gyldig e-mail.", emailEl);

    button.disabled = true;
    var label = button.textContent;
    button.textContent = "Sender…";

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: name,
        email: email,
        handle: form.dataset.handle,
        page: window.location.href,
        website: form.querySelector('[name="website"]').value,
      }),
    })
      .then(function (r) {
        return r.json().catch(function () { return { ok: false }; });
      })
      .then(function (data) {
        if (!data || !data.ok) throw new Error((data && data.error) || "Noget gik galt.");
        var body = form.closest(".dms-modal-body");
        body.querySelector("[data-dms-brochure-email]").textContent = email;
        form.hidden = true;
        body.querySelector(".dms-brochure-success").hidden = false;
        if (window.dataLayer) window.dataLayer.push({ event: "brochure_lead", product_handle: form.dataset.handle });
      })
      .catch(function (err) {
        showError((err && err.message ? err.message : "Noget gik galt.") + " Prøv igen, eller ring 70 22 37 00.");
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = label;
      });
  }, true);
})();
